import { Phone, Droplets } from "lucide-react";
import { BUSINESS } from "../lib/constants";

export const TopBar = () => (
  <div className="bg-brand-dark text-white" data-testid="top-trust-bar">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 h-9 flex items-center justify-between gap-4">
      <p className="text-[11px] sm:text-xs font-medium tracking-wide truncate">
        Gold Coast Local <span className="text-white/40 mx-1.5">•</span> 7+ Years Experience
        <span className="hidden sm:inline"><span className="text-white/40 mx-1.5">•</span> Residential & Commercial Cleaning</span>
      </p>
      <a
        href={BUSINESS.phoneHref}
        data-testid="topbar-water-damage-link"
        className="inline-flex items-center gap-1.5 text-[11px] sm:text-xs font-semibold text-[#A7E3DC] hover:text-white transition-colors duration-300 shrink-0"
      >
        <Droplets size={13} />
        Water Damage? <span className="hidden xs:inline sm:inline">Call</span> {BUSINESS.phoneDisplay}
        <Phone size={12} className="sm:hidden" />
      </a>
    </div>
  </div>
);
